var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowNs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 12,
  viewBox: "0 0 15 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 2v6.658l1.5-2.142h.508c.55 0 .992.446.992.997v.51l-3.321 3.665a.895.895 0 0 1-1.358 0L7 8.022v-.51c0-.552.444-.996.992-.996H8.5L10 8.658V2zM4.679.312 8 3.978v.51c0 .55-.442.996-.992.996H6.5L5 3.342V10H3V3.342L1.5 5.484H.992A.993.993 0 0 1 0 4.487v-.51L3.321.313a.895.895 0 0 1 1.358 0"
})));
export default SvgArrowNs;